import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "list", "row", "destroyInput"]

  add(event) {
    event.preventDefault()

    const index = `${Date.now()}${Math.floor(Math.random() * 1000)}`
    const content = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", index)
    this.listTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-provider-lines-target='row']")
    const destroyInput = row.querySelector("input[name$='[_destroy]']")

    if (destroyInput && row.querySelector("input[name$='[id]']")) {
      destroyInput.value = "1"
      row.hidden = true
    } else {
      row.remove()
    }
  }
}
